import { SeriesSummaryModel, SiteSettingModel } from "@api/models";

export function SeriesHeaderFanletterBtn({
  series,
  siteSettings,
}: {
  series: SeriesSummaryModel;
  siteSettings: SiteSettingModel;
}) {
  return (
    <div className="series-h-fanletter-btn-wrap">
      <a
        className="series-h-fanletter-btn"
        href={siteSettings.fanLetterLink + encodeURIComponent(series.name)}
        target="_blank"
      >
        ファンレターを送る
      </a>
    </div>
  );
}
